import axios from 'axios';

const request = axios.create({
  // wpBaseURL: process.env.WORDPRESS_REST_API || 'https://dev.paulmfitness.com:8890/wp-json/',
  wpBaseURL: process.env.WORDPRESS_REST_API,
  withCredentials: true
})

export default request;